var exports = {
  "k": "x127c5a35--9df9b3--container",
  "h": "x127c5a35--9df9b3--activation-hint",
};

module.exports = exports;
